import React from 'react';
export const UnionCardIcon = () => (
    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.291 5.9375H3.16602V2.375H10.291V5.9375ZM10.291 1.58366H3.16602V0.791992H10.291V1.58366ZM3.16667 0H10.2917C10.7287 0 11.0833 0.354667 11.0833 0.791667V5.9375C11.0833 6.3745 10.7287 6.72917 10.2917 6.72917H3.16667C2.72967 6.72917 2.375 6.3745 2.375 5.9375V0.791667C2.375 0.354667 2.72967 0 3.16667 0ZM0.791667 8.70801H7.91667V7.52051H8.70833V8.70801C8.70833 9.14501 8.35367 9.49967 7.91667 9.49967H0.791667C0.354667 9.49967 0 9.14501 0 8.70801V3.56217C0 3.12517 0.354667 2.77051 0.791667 2.77051H1.58333V3.56217H0.791667V8.70801Z"
            fill="#006A9E"
        />
    </svg>
);
